<template>
  <error-page-layout
    icon="cancel"
    error-type="Erro 404"
    color-type="error"
    title="Não achou o que buscava?"
    first-message="O conteúdo que você está buscando não existe."
    second-message="Confira o endereço digitado ou volte para a Home."
    image-name="404.png"
  >
    <mf-button slot="buttons" text color="orange" label="Voltar para home" @click="$router.push('/')" />
  </error-page-layout>
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
export default {
  components: {
    ErrorPageLayout,
  },
}
</script>
